import { render, staticRenderFns } from "./RequestedCalls.vue?vue&type=template&id=2032ab66&"
import script from "./RequestedCalls.vue?vue&type=script&lang=js&"
export * from "./RequestedCalls.vue?vue&type=script&lang=js&"
import style0 from "./RequestedCalls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports